import { trpc } from 'api'
import { useTranslation } from 'react-i18next'
import { useToast } from '@ui/toasts/useToastManager'
import { Customer, VerifyStrategyType } from '@ca/common/types'
import useLoginCallback from 'hooks/useLoginCallback'

import { CODE_LENGTH } from './types'

interface Args {
  id?: number
  login: string
  strategy: VerifyStrategyType
  replace?: boolean
  onSuccess?: (data: Customer) => void
  onError?: () => void
}

export const useSubmitAuthCode = ({
  login,
  strategy,
  id,
  replace,
  onSuccess,
  onError,
}: Args) => {
  const { t } = useTranslation(['auth', 'common'])
  const toast = useToast()

  const signIn = trpc.customer.loginWithCode.useMutation()
  const onSignIn = useLoginCallback(replace)

  const onSubmit = (code: string) => {
    signIn.mutate(
      {
        code,
        login,
        strategy,
        id,
      },
      {
        onSuccess: (res, req) => {
          onSuccess?.(res.data)
          onSignIn(res, req)
        },
        onError: (err) => {
          if (err?.data?.code === 'BAD_REQUEST') {
            onError?.()
            toast({
              title: t('auth:invalidCode.title'),
              text: t('auth:invalidCode.text'),
              variant: 'error',
            })
            return
          }
          // Default error
          toast({
            title: t('toasts:error.default.title'),
            text: t('toasts:error.default.text'),
            variant: 'error',
          })
        },
      }
    )
  }
  return { onSubmit, isLoading: signIn.isPending }
}
